import { string } from 'prop-types';
import { prop } from 'ramda';
import React, { FC, useCallback } from 'react';
import { Route, Switch, useHistory } from 'react-router';
import { compose, setDisplayName, setPropTypes } from 'recompose';
import { RoutePath } from '../../constants/Routes';
import { MainSource } from '../../constants/Source';
import { withFolderPath } from '../../utils/hoc/withFolderPath';
import { withItemsLoader } from '../../utils/hoc/withItemsLoader';
import { withItemsReducer } from '../../utils/hoc/withItemsReducer';
import { useMediaManagerSDK } from '../../utils/hooks/useMediaManagerSDK';
import { RouteBuilder } from '../../utils/RouteHelpers';
import { IInner, IOuter } from './ModalFilesManager.types';
import { SystemFolderId } from '../../constants/SystemFolderId';

const withFolderIdAndNavigateToFolder = (BaseComponent) => {
  const WithFolderIdAndNavigateToFolder: FC = (props) => {
    const mmgrSDKHandlers = useMediaManagerSDK({ source: MainSource.SiteFiles });

    const history = useHistory();
    const navigateToFolder = useCallback(
      (folderId) => {
        history.push(RouteBuilder.Source(MainSource.SiteFiles, folderId));
      },
      [history],
    );

    return (
      <Switch>
        <Route path={RoutePath.Source}>
          {({
            match: {
              params: { folderId, source = MainSource.SiteFiles },
            },
          }) => (
            <BaseComponent
              {...props}
              {...mmgrSDKHandlers}
              navigateToFolder={navigateToFolder}
              folderId={folderId}
              source={source}
            />
          )}
        </Route>
        <Route path={RoutePath.Search}>
          <BaseComponent
            {...props}
            {...mmgrSDKHandlers}
            navigateToFolder={navigateToFolder}
            folderId={SystemFolderId.SiteFiles}
            source={MainSource.SiteFiles}
          />
        </Route>
      </Switch>
    );
  };

  WithFolderIdAndNavigateToFolder.displayName = 'WithFolderIdAndNavigateToFolder';

  return WithFolderIdAndNavigateToFolder;
};

export const enhance = compose<IInner, IOuter>(
  setPropTypes({
    fileType: string.isRequired,
  }),
  setDisplayName('ModalFilesManagerEnhance'),
  withFolderIdAndNavigateToFolder,
  withFolderPath(),
  withItemsLoader(prop('itemsLoaderConfig'), ['itemsLoaderConfig']),
  withItemsReducer,
);
